import React from 'react';
import './App.css';
import {Route, Routes, useNavigate } from 'react-router-dom';
import Dashboard from "./ui/components/dashboard";
import Login from './ui/auth/Login';
import Logout from './ui/auth/Logout';
import CommentsWindow from "./ui/comments/CommentsWindow";
import Games from './ui/components/Games';
import AdminWindow from './ui/AdminWindow/AdminWindow';
import UsersList from './ui/AdminWindow/users';
import NewUserForm from './ui/AdminWindow/NewUserForm';
import EditUserForm from './ui/AdminWindow/EditUserForm';
import Game from "./ui/components/Game";
import Test from './Test';


function App() {

  const navigate = useNavigate();
  const routeChange = () =>{ 
    let path = `login`; 
    navigate(path);
  }
  
  return (
    <div className="wrapper">
        <Routes>
          <Route path="/" element={<Login redirect="/dashboard" />}/>
          <Route path="/login" element={<Login redirect="/dashboard" />}/>
          <Route path="/logout" element={<Logout redirect="/login" />}/>
          <Route path="/dashboard" element={<Dashboard />}/>
          <Route path="/games" element={<Games />}/>
          <Route path="/game" element={<Game />}/>
          <Route path="/users" element={<UsersList />}/>
          <Route path="/create" element={<NewUserForm />}/>
          <Route path="/edit" element={<EditUserForm />}/>
          <Route path="/admin" element={<AdminWindow />}/>
          <Route path="/comments" element={<CommentsWindow />}>
            <Route path=':commentId' element={<CommentsWindow />}/>
          </Route>
          <Route path="/test" element={<Test />}/>
          
        </Routes>
    </div>
  );
}

export default App;
